<template>
  <div>
    <view-table
        ref="viewTable"
        :limits="limits"
        :columns-property="columnsProperty"
        :filter="filter"
        module="basic"
        url="mES_Teams"
        @addOrEdit="addEditHandle"
        @delete="deleteHandle"
        @reset="resetHandle"
    >
      <template slot="adSearch">
        <el-form :inline="true" :model="filter" @keyup.enter.native="loadData(1)">
          <el-form-item label="班组编码">
            <el-input v-model.trim="filter.teamCode" placeholder="请输入班组编码" clearable/>
          </el-form-item>
          <el-form-item label="班组名称">
            <el-input v-model.trim="filter.teamName" placeholder="请输入班组名称" clearable/>
          </el-form-item>
          <el-form-item label="工厂编码">
            <el-input v-model.trim="filter.plantCode" placeholder="请输入工厂编码" clearable/>
          </el-form-item>
          <el-form-item label="车间编码">
            <el-input v-model.trim="filter.workshopCode" placeholder="请输入车间编码" clearable/>
          </el-form-item>
          <el-form-item label="班组状态">
            <el-select v-model="filter.teamStatus" clearable placeholder="请选择状态" style="width:140px">
              <el-option label="启用" :value="1"/>
              <el-option label="停用" :value="0"/>
            </el-select>
          </el-form-item>
        </el-form>
      </template>
    </view-table>
    <team-edit ref="teamEdit" @save-success="loadData"/>
  </div>
</template>

<script>
  import ViewTable from "@/components/ViewTable";
  import TeamEdit from "./TeamEdit";

  export default {
    name: "TeamList",
    components: { TeamEdit, ViewTable },
    data() {
      return {
        limits: {
          addAuth: this.$auth(4),
          editAuth: this.$auth(7),
          delAuth: this.$auth(9),
        },
        filter: {
          teamCode: "",
          teamName: "",
          plantCode: "",
          workshopCode: "",
          teamStatus: null,
        },
        columnsProperty: [
          {
            key: "teamCode",
            width: 130,
            align: "center",
            render: (h, params) => {
              return h(
                "span",
                {
                  style: {
                    color: "#2d8cf0",
                    cursor: "pointer",
                    fontWeight: "bold",
                  },
                  on: {
                    click: () => {
                      this.$refs.teamEdit.open(params.row, true);
                    },
                  },
                },
                params.row.teamCode
              );
            },
          },
          { tooltip: true, key: "teamName", width: 160 },
          { tooltip: true, key: "defaultCalendarName", width: 140 },
          { tooltip: true, key: "plantCode", align: "center", width: 110 },
          { tooltip: true, key: "workshopCode", align: "center", width: 110 },
          { tooltip: true, key: "teamLeaderName", align: "center", width: 110 },
          { key: "standardPersonNum", align: "center", width: 100 },
          { key: "teamStatusName", align: "center", width: 100 },
          { tooltip: true, key: "createTime", align: "center", width: 150 },
          { key: "action", width: 140, slot: "action", fixed: "right" },
        ],
      };
    },
    methods: {
      loadData(pageNum) {
        this.$refs.viewTable.loadData(pageNum);
      },
      addEditHandle(row) {
        this.$refs.teamEdit.open(row);
      },
      deleteHandle(row) {
        this.$http.delete("basic", "mES_Teams", row.id).then((resp) => {
          if (resp.success) {
            this.loadData();
            this.$message.success("删除成功");
          }
        });
      },
      resetHandle(filter) {
        this.filter = Object.assign(this.filter, filter);
      },
    },
  };
</script>
